import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { User, ISort } from '@homeviews/models'

export const USERS_FEATURE_KEY = 'users'

type UsersState = {
  users: User[]
  sort?: ISort
}

const initialUsersState: UsersState = {
  users: [],
  sort: null,
}

export const usersSlice = createSlice({
  name: USERS_FEATURE_KEY,
  initialState: initialUsersState,
  reducers: {
    setCompanyUsersSort: (
      state,
      { payload: { sort } }: PayloadAction<{ sort: ISort }>,
    ) => {
      state.sort = sort
    },
  },
})

/*
 * Export reducer for store configuration.
 */
export const usersReducer = usersSlice.reducer

export const { setCompanyUsersSort } = usersSlice.actions

export const selectActiveUsersSort = (rootState: unknown) =>
  rootState[USERS_FEATURE_KEY]?.sort

export const getUsersState = (rootState: unknown): UsersState =>
  rootState[USERS_FEATURE_KEY]
